const $window = $(window);
const breakPoint = 768;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();
//const bodyLimitHeight = (windowHeight - 185) * 0.88;

let url = location.href;

// preload
const preload = () =>{
  let timer = 0;
  $(window).on('load' , function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("body").removeClass("preload");
    }, 100);
  });
};

// resizing
const resizing = () =>{
  let timer = 0;
  $(window).on('resize' , function() {
    let resizeWidth = $window.width();
    if(windowWidth !== resizeWidth){
      $("body").addClass("resizing");
      if (timer > 0) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        $("body").removeClass("resizing");
      }, 100);
    }
    windowWidth = resizeWidth;
  });
};

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};

// ------------------------------------------------------------------------
// headerPin
// ------------------------------------------------------------------------
const headerPin = () => {
  $(window).on("load", function () {
    let rate = windowWidth / windowHeight;
    if (matchMedia('(min-width: 769px)').matches && rate > 1.43) {
    // if (matchMedia('(min-width: 1301px)').matches && rate > 1.43) {
      ScrollTrigger.create({
        trigger: '.st-Header',
        pin: '.st-Header_Bar',
        end: 'bottom bottom',
      })
    }
  });
};

// // ------------------------------------------------------------------------
// // kv_animation
// // ------------------------------------------------------------------------
// const kv_animation = () => {
//   let winScroll = $(window).scrollTop();
//   let winHeight = $(window).height();
//   // js-Animation
//   $('.js-Animation-kv').each(function(){
//     let target = $(this);
//     target.addClass('animated');
//   });
// };

// ------------------------------------------------------------------------
// js-Animation
// ------------------------------------------------------------------------
const scrollAnimation = () => {
  let winScroll = $(window).scrollTop();
  let winHeight = $(window).height();
  // js-Animation
  $('.js-Animation').each(function(){
    let target = $(this);
    if(target.offset().top < winScroll + (winHeight * .9)) {
      target.addClass('animated');
    }
  });
};

/*-------------------------------------------------------------------*/
/* movieモーダル */
/*-------------------------------------------------------------------*/
// movie
const showMovie = () => {
  const $modal = $('#movie-Stage');
  const $content = $('#movie-Iframe');

  // open
  $('body').on('click', '.js-Youtube', function(){

    const dataID = $(this).attr('data-youtube');

    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},300,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // // fadeIn
      // $modal.stop().fadeIn(400);
      return false;
    });
  });

  //close
  $('#movie-Close,#movie-Iframe').on('click', function(){

    $('#movie-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#movie-Stage').css({'display':'none'});
      $content.children('iframe').remove();
    });
  });
};

// ------------------------------------------------------------------------
// headerToggle
// ------------------------------------------------------------------------
const headerToggle = () => {
  const $header = $('.st-Header');
  // const $header_btn = $('.st-Header .st-Header_Hamburger');
  const $header_btn = $('.st-Header .st-Header_Menu');
  const $header_link = $('.st-Header a[href^=#]');
  // const $header_link = $('.st-Header a[href^="#"]');
  $header_btn.on('click', function(){
    $header.toggleClass('active');
    // $('body').toggleClass('noscrollBar');
  });
  $header_link.click(function () {
    $header.removeClass('active');
    // $('body').removeClass('noscrollBar');
    return false;
  });
};

//export
export {preload, resizing, anchorScroll, scrollAnimation, showMovie, headerPin,headerToggle};



// WEBPACK FOOTER //
// ./src/mobpsycho3rd/assets/js/include/module.js